import { formatOrAnonymize } from "./format-or-anonymize";

export function toOneDecimalString(value?: string | number | null): string {
  const oneDecimalStringOrAnonymized = formatOrAnonymize(value, (value) => Number(value).toFixed(1).replace('.', ','))
  return oneDecimalStringOrAnonymized;
}